<div class="refund-bg"></div>
<div class="refund-container">
    <app-card-info cardTitle="Información de la devolución" titleClass="ps-6" iconCard="../../../../assets/img/ic-i.svg">
        <div class="contenido border-indigo-50">
            <div class="parrafo text-opacity-50 text-[14px] font-normal font-['Inter'] leading-tight mb-6 text-left">
                El plazo para la devolución del dinero a la cuenta del cliente estará sujeto a las políticas específicas de cada banco emisor.
                <div class=" py-1">
                    <hr class="border-solid mt-2"/>
                </div>
            </div>
            <div class="text-start">
                <div class="flex justify-between items-center mb-6">
                    <span class="nuevo inline-block text-[15px] font-semibold font-['Inter'] leading-[18.37px]">
                        Monto devolución
                    </span>
                    <div>
                        <input  
                        type="text" 
                        class="campos w-[222px] h-[42px] justify-end ml-auto" 
                        placeholder="Ingrese monto" 
                        pattern="[0-9]*"
                        [(ngModel)]="inputValue"
                        (input)="formatCurrency()"
                        (keypress)="validateInput($event)"
                        [ngClass]="{
                            'exceeding-limit': isExceedingLimit()
                        }"
                        required
                        />

                        @if(isExceedingLimit()) {
                            <span class="error-message">
                                El límite de devolución es de {{diferencia.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}}
                            </span>
                        }
                    </div>
                    
                </div>
                <div class="flex justify-between items-center mb-4">
                    <span class="nuevo inline-block text-[15px] font-semibold font-['Inter'] leading-[18.37px]">
                        Razón
                    </span>
                    <select class="campos w-[222px] h-[42px] rounded-md border border-indigo-400 justify-end ml-auto">
                        <option value="opcion1">Venta duplicada</option>
                        <option value="opcion2">Solicitado por el cliente</option>
                        <option value="opcion3">Otro</option>
                    </select>                    
                </div>
                <div class="mb-4">
                    <textarea
                        maxlength="151"
                        [(ngModel)]="textValue"
                        class="campos pt-3 w-full h-[137px] pb-[2px] rounded-md border border-indigo-400 ml-auto"
                        placeholder="Añade el motivo del reembolso"
                        (input)="validateTextarea()"
                        [ngClass]="{'exceeding-limit': showErrorMessage}"
                    ></textarea>

                    <div *ngIf="showErrorMessage" class="error-message-text">
                    El texto supera los 150 caracteres, por favor vuelva a escribir un motivo más breve.
                    </div>

                    <span class="text-neutral-600 text-[11px] font-normal font-['Inter'] leading-tight">
                        El motivo del reembolso debe tener un máximo de 150 caracteres.
                    </span>
                </div>
                <div class="flex justify-between">
                    <button (click)="handleClick(true)" class="w-[221.64px] h-[38.74px] bg-white rounded-xl border border-zinc-400 mr-4">
                        <div class="text-zinc-400 text-xs font-bold font-['Poppins']">Volver</div>
                    </button>
                    <button (click)="makeRefund()" [attr.disabled]="isButtonDisabled() ? true: null" class="w-[221.64px] h-[38.74px] bg-indigo-500 rounded-xl flex items-center justify-center disabled:cursor-not-allowed disabled:bg-indigo-300">
                        @if(loading) {
                            <div class="load ml-4 flex items-center" role="status">
                                <svg aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                            <div class="mensaje text-white text-xs font-bold font-['Poppins'] flex-grow flex ml-2 items-center">Continuar devolución</div>
                        } @else {
                            <div class="mensaje text-white text-xs font-bold font-['Poppins'] flex-grow flex items-center justify-center">Continuar devolución</div>
                        }
                    </button>
                    
                    
                </div>
            </div>
            
        </div>
    </app-card-info>
</div>